/**
 * 下单时的委托单位
 * 注意 这里是抽象的单位，不是具体的。比如抽象概念是 byCoin，具体的是 btc、eth 等等
 *
 * cont 是我们抽象的合约单位，张
 * value 是交易币对中的 稳定币一方(价值代表方)，比如 BTCUSD 中的 usd，BTCUSDC 中的 usdc
 * coin 是交易币对中的 非稳定货币，比如 BTCUSD 中的 btc，BTCUSDC 中的 btc
 */
export enum QtyType {
  Cont = 'ByCont',
  Base = 'ByValue',
  Coin = 'ByCoin',
}
